export function markdownItToConsumer(md: any, editorId: string) {
  md.configure('default').set({ linkify: true });
  md.linkify.set({ fuzzyEmail: false, fuzzyLink: true, fuzzyIP: false });
  // if (isCommentEditor(editorId)) {
  //   md.disable('image');
  // }
}
